<template>
  <tr>
    <td colspan="2">
      <table style="width: 100%;">
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td bgcolor="#e6ecf1">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Your ORDER ID: {{ booking.transaction.transaction_id }}
              <small>(this is NOT your booking ref)</small>
            </font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <table width="100%" style="font-weight: normal; font-size: 14px; color:#000000; border: 1px solid #dddddd;" border="1">

              <tr bgcolor="#e6ecf1">
                <td>Product</td>
                <td>Quantity</td>
                <td>Price</td>
                <td>Discount</td>
                <td>Total</td>
              </tr>

              <tr v-for="(item, key) in booking.bookings.airportparking" :key="`ap-${key}-summary`">
                <td>{{ item.product.park_name || item.product.product_name }}</td>
                <td>1</td>
                <td>&pound;{{ item.booking.full_price.toFixed(2) }}</td>
                <td>&pound;{{ item.booking.discount.toFixed(2) }}</td>
                <td>&pound;{{ item.booking.sale_price.toFixed(2) }}</td>
              </tr>

              <tr v-for="(item, key) in booking.bookings.airporthotel" :key="`ah-${key}-summary`">
                <td>{{ item.product.hotel_name || item.product.product_name }}</td>
                <td>1</td>
                <td>&pound;{{ item.booking.sale_price.toFixed(2) }}</td>
                <td>&pound;{{ item.booking.discount.toFixed(2) }}</td>
                <td>&pound;{{ item.booking.sale_price.toFixed(2) }}</td>
              </tr>

              <tr v-for="(item, key) in booking.bookings.airportlounge" :key="`al-${key}-summary`">
                <td>{{ item.product.lounge_name || item.product.product_name }}</td>
                <td>1</td>
                <td>&pound;{{ item.booking.sale_price.toFixed(2) }}</td>
                <td>&pound;{{ item.booking.discount.toFixed(2) }}</td>
                <td>&pound;{{ item.booking.sale_price.toFixed(2) }}</td>
              </tr>

              <tr v-for="(item, key) in booking.bookings.addon" :key="key">
                <td>{{ item.product.addon_name }}</td>
                <td>1</td>
                <td>&pound;{{ item.booking.amount.toFixed(2) }}</td>
                <td>&pound;0.00</td>
                <td>&pound;{{ item.booking.amount.toFixed(2) }}</td>
              </tr>

              <tr>
                <td colspan="4">Total cost inc. VAT</td>
                <td>&pound;{{ booking.transaction.amount_paid.toFixed(2) }}</td>
              </tr>


              <tr v-if="credits && credits > 0">
                <td colspan="4">Credits used</td>
                <td>&pound;{{ credits.toFixed(2) }}</td>
              </tr>



              <tr>
                <td colspan="4">
                  <i>VAT included in the above</i>
                </td>
                <td style="font-weight: normal; color: rgb(50, 50, 50);">
                  <i>&pound;{{ (booking.transaction.vat_total).toFixed(2) }}</i>
                </td>
              </tr>

              <tr>
                <td colspan="4" style="font-weight: normal; color: rgb(50, 50, 50);">Payment method</td>
                <td style="font-weight: normal; color: rgb(50, 50, 50);">
                  {{ booking.transaction.payment_type === 'Checkout' ? 'Card' : 'PayPal' }}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>

        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Skyparksecure Ltd, 6th Floor Olympic House, Manchester Airport, Manchester, England, M90 1QX. 
              <br />VAT number: 82 53349 29.
              <br />This is a VAT Receipt
            </font>
          </td>
        </tr>

        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>

      </table>
    </td>
  </tr>
</template>

<script>
export default {
  name: "confirmation-view-summary",
  props: { 
    booking: { type: Object }
  },
  computed: {
    credits() {
      let transactions = this.booking.transactions.filter(item => item.money_type === 'credits' && item.action_type === 'out');
      return transactions.length > 0 ? transactions[0].amount_paid : 0;
    }
  }
};
</script>